var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrequal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438.03 304.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1uui1124,.cls-2uui1124,.cls-3uui1124,.cls-4uui1124{fill:none;}.cls-1uui1124,.cls-5uui1124,.cls-6uui1124{stroke-width:0px;}.cls-2uui1124{stroke-dasharray:0 0 0 6;stroke-linecap:round;stroke-width:2px;}.cls-2uui1124,.cls-3uui1124{stroke:#004f68;}.cls-2uui1124,.cls-3uui1124,.cls-4uui1124{stroke-miterlimit:10;}.cls-4uui1124{stroke:#f0f0de;}.cls-5uui1124{fill:#009ed9;}.cls-6uui1124{fill:#f5faf9;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1uui1124",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1uui1124",
    width: 438.03,
    height: 304.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5uui1124",
    d: "m170.64,60.58c-5.93,4.32-16.5,4.2-20.82,10.13-4.27,5.87-.93,15.87-3.22,22.92-2.21,6.81-10.87,12.89-10.87,20.44s8.66,13.63,10.87,20.44c2.29,7.06-1.06,17.05,3.22,22.92,2.87,3.94,8.49,5.22,13.69,6.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5uui1124",
    d: "m163.51,164.33v106.12l45.71-34.94,44.78,34.94v-105.62c5.57-1.95,12.03-3.07,15.17-7.39,4.27-5.87.93-15.87,3.22-22.92,2.21-6.81,10.87-12.89,10.87-20.44s-8.66-13.63-10.87-20.44c-2.29-7.06,1.06-17.05-3.22-22.92-4.32-5.93-14.89-5.81-20.82-10.13-5.87-4.27-9-14.39-16.06-16.68-6.81-2.21-15.26,4.06-22.8,4.06s-15.99-6.27-22.8-4.06c-7.06,2.29-10.19,12.4-16.06,16.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3uui1124",
    x1: 254.01,
    y1: 223.11,
    x2: 254.01,
    y2: 164.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3uui1124",
    d: "m232.3,43.9c-6.81-2.21-15.26,4.06-22.8,4.06s-15.99-6.27-22.8-4.06c-7.06,2.29-10.19,12.4-16.06,16.68-5.93,4.32-16.5,4.2-20.82,10.13-4.27,5.87-.93,15.87-3.22,22.92-2.21,6.81-10.87,12.89-10.87,20.44s8.66,13.63,10.87,20.44c2.29,7.06-1.06,17.05,3.22,22.92,2.87,3.94,8.49,5.22,13.69,6.9"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4uui1124",
    cx: 208.76,
    cy: 114.07,
    r: 52.74
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4uui1124",
    points: "178.46 157.2 178.46 235.1 208.76 209.1 240.53 235.1 240.53 156.17"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6uui1124",
    x: 185.88,
    y: 104.69,
    width: 47.24,
    height: 35.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6uui1124",
    points: "209.5 84.31 176.93 106.72 242.06 106.72 209.5 84.31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5uui1124",
    x: 201.45,
    y: 122.64,
    width: 16.51,
    height: 18.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 125.65,
    y1: 129.09,
    x2: 26.59,
    y2: 129.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 396.89,
    y1: 129.09,
    x2: 297.83,
    y2: 129.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 304.5,
    y1: 69.93,
    x2: 359.67,
    y2: 34.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 305.82,
    y1: 184,
    x2: 363.64,
    y2: 221.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 126.97,
    y1: 185.7,
    x2: 71.8,
    y2: 221.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 125.65,
    y1: 71.63,
    x2: 67.83,
    y2: 34.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 314.99,
    y1: 98.99,
    x2: 376.68,
    y2: 81.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 316.47,
    y1: 155.79,
    x2: 381.12,
    y2: 174.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 116.48,
    y1: 156.63,
    x2: 54.79,
    y2: 174.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2uui1124",
    x1: 115.01,
    y1: 99.84,
    x2: 50.36,
    y2: 81.37
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequal);
export default __webpack_public_path__ + "static/media/prequal.91a9f686d356155034516689a6b315eb.svg";
export { ForwardRef as ReactComponent };